import styled from '@emotion/styled';
import {css} from '@emotion/css';

/*
 * Remedy's Banner only renders {children, type, className} and has no native dismiss affordance
 * (CARECO-6086). We lay the banner body and a Remedy IconButton (close) in a flex row so the
 * message takes the available width and the dismiss control sits at the trailing edge.
 */
export const BannerBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

/*
 * Banner wraps our children in a shrink-to-fit text div, so BannerBody's full width stops at the
 * message and the X sits right after the text. Applied to the Banner, this stretches that text
 * wrapper to fill the row so the dismiss control is pinned to the banner's far-right edge
 * regardless of message length (CARECO-6086).
 */
export const dismissibleBannerClass = css`
  & > div:last-of-type {
    flex: 1;
  }
`;

export const BannerMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
